import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Alert, Tabs, Tab, Row, Col } from 'react-bootstrap';
import TwilioSettings from './TwilioSettings';

const GeneralSettings = () => {
  const [activeTab, setActiveTab] = useState('general');
  const [settings, setSettings] = useState({
    // General Settings
    siteName: 'Teve',
    siteDescription: 'Best Video Streaming Software',
    contactEmail: 'admin@app.teve.ca',
    timezone: 'UTC',
    
    // Stream Settings
    streamServerUrl: 'app.teve.ca',
    maxStreamsPerUser: 5,
    autoRecordStreams: false,
    defaultStreamQuality: '1080p',
    
    // Security Settings
    requireEmailVerification: false,
    sessionTimeout: 60,
    maxLoginAttempts: 5,
    
    // Notification Settings
    emailNotifications: true,
    streamStartNotification: true,
    streamEndNotification: true,
    adminAlerts: true
  });
  
  const [saved, setSaved] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real app, this would save to backend
    localStorage.setItem('teve_settings', JSON.stringify(settings));
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  useEffect(() => {
    // Load saved settings
    const saved = localStorage.getItem('teve_settings');
    if (saved) {
      setSettings(JSON.parse(saved));
    }
  }, []);

  return (
    <div className="container-fluid">
      <h2 className="mb-4">General Settings</h2>
      
      {saved && <Alert variant="success">Settings saved successfully!</Alert>}
      
      <Card>
        <Card.Body>
          <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="mb-3">
            <Tab eventKey="general" title="General">
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Site Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="siteName"
                        value={settings.siteName}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Contact Email</Form.Label>
                      <Form.Control
                        type="email"
                        name="contactEmail"
                        value={settings.contactEmail}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                
                <Form.Group className="mb-3">
                  <Form.Label>Site Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="siteDescription"
                    value={settings.siteDescription}
                    onChange={handleChange}
                  />
                </Form.Group>
                
                <Form.Group className="mb-3">
                  <Form.Label>Timezone</Form.Label>
                  <Form.Select name="timezone" value={settings.timezone} onChange={handleChange}>
                    <option value="UTC">UTC</option>
                    <option value="America/New_York">Eastern Time</option>
                    <option value="America/Chicago">Central Time</option>
                    <option value="America/Denver">Mountain Time</option>
                    <option value="America/Los_Angeles">Pacific Time</option>
                    <option value="Europe/London">London</option>
                    <option value="Europe/Paris">Paris</option>
                    <option value="Asia/Tokyo">Tokyo</option>
                  </Form.Select>
                </Form.Group>
                
                <Button variant="primary" type="submit">Save Changes</Button>
              </Form>
            </Tab>

            <Tab eventKey="stream" title="Stream Settings">
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Stream Server URL</Form.Label>
                      <Form.Control
                        type="text"
                        name="streamServerUrl"
                        value={settings.streamServerUrl}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Max Streams Per User</Form.Label>
                      <Form.Control
                        type="number"
                        name="maxStreamsPerUser"
                        value={settings.maxStreamsPerUser}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                
                <Form.Group className="mb-3">
                  <Form.Label>Default Stream Quality</Form.Label>
                  <Form.Select name="defaultStreamQuality" value={settings.defaultStreamQuality} onChange={handleChange}>
                    <option value="720p">720p</option>
                    <option value="1080p">1080p</option>
                    <option value="1440p">1440p</option>
                    <option value="4K">4K</option>
                  </Form.Select>
                </Form.Group>
                
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Auto-record all streams"
                    name="autoRecordStreams"
                    checked={settings.autoRecordStreams}
                    onChange={handleChange}
                  />
                </Form.Group>
                
                <Button variant="primary" type="submit">Save Changes</Button>
              </Form>
            </Tab>

            <Tab eventKey="security" title="Security">
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Require email verification"
                    name="requireEmailVerification"
                    checked={settings.requireEmailVerification}
                    onChange={handleChange}
                  />
                </Form.Group>
                
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Session Timeout (minutes)</Form.Label>
                      <Form.Control
                        type="number"
                        name="sessionTimeout"
                        value={settings.sessionTimeout}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Max Login Attempts</Form.Label>
                      <Form.Control
                        type="number"
                        name="maxLoginAttempts"
                        value={settings.maxLoginAttempts}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                
                <Button variant="primary" type="submit">Save Changes</Button>
              </Form>
            </Tab>

            <Tab eventKey="twilio" title="Twilio SMS">
              <TwilioSettings />
            </Tab>

            <Tab eventKey="notifications" title="Notifications">
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Enable email notifications"
                    name="emailNotifications"
                    checked={settings.emailNotifications}
                    onChange={handleChange}
                  />
                </Form.Group>
                
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Stream start notification"
                    name="streamStartNotification"
                    checked={settings.streamStartNotification}
                    onChange={handleChange}
                  />
                </Form.Group>
                
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Stream end notification"
                    name="streamEndNotification"
                    checked={settings.streamEndNotification}
                    onChange={handleChange}
                  />
                </Form.Group>
                
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Admin alerts"
                    name="adminAlerts"
                    checked={settings.adminAlerts}
                    onChange={handleChange}
                  />
                </Form.Group>
                
                <Button variant="primary" type="submit">Save Changes</Button>
              </Form>
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>
    </div>
  );
};

export default GeneralSettings;
